import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import Home from './pages/Home';
import Jobs from './pages/Jobs';
import JobDetail from './pages/JobDetail';
import { Login, Register, ForgotPassword, ResetPassword, LinkedInCallback } from './pages/Auth';
import { HelmetProvider } from 'react-helmet-async';
import { getCountry, getCountryBase } from './services/country';

const CandidateDashboard = React.lazy(() => import('./pages/CandidateDashboard'));
const CompanyDashboard   = React.lazy(() => import('./pages/CompanyDashboard'));
const NewJob             = React.lazy(() => import('./pages/NewJob'));
const Companies          = React.lazy(() => import('./pages/Companies'));
const Pricing            = React.lazy(() => import('./pages/Pricing'));
const NotFound           = React.lazy(() => import('./pages/NotFound'));
const CandidatePublic    = React.lazy(() => import('./pages/CandidatePublic'));
const AdminDashboard     = React.lazy(() => import('./pages/AdminDashboard'));
const JobsMap            = React.lazy(() => import('./pages/JobsMap'));

const Loader = () => (
  <div style={{ display:'flex', justifyContent:'center', alignItems:'center', minHeight:'50vh' }}>
    <div className="spinner" />
  </div>
);

function ProtectedRoute({ children, role }) {
  const { user, loading } = useAuth();
  if (loading) return <Loader />;
  if (!user) return <Navigate to="/login" replace />;
  if (role && user.role !== role) return <Navigate to="/" replace />;
  return children;
}

function AppLayout() {
  const country=getCountry();
  if(!country.active)return <><Navbar/><main style={{minHeight:'calc(100vh - 64px - 200px)',display:'grid',placeItems:'center',padding:'3rem 1rem'}}>
    <section className="card" style={{maxWidth:620,textAlign:'center',padding:'3rem'}}>
      <div style={{fontSize:'3rem'}}>{country.flag}</div><h1>TalentosRD llega pronto a {country.name}</h1>
      <p>Estamos preparando empresas, vacantes y recursos locales antes de abrir este mercado.</p>
      <a href="/do" className="btn btn-primary">Ver empleos en República Dominicana</a>
    </section>
  </main><Footer/></>;
  return (
    <>
      <Navbar />
      <main style={{ minHeight: 'calc(100vh - 64px - 200px)' }}>
        <React.Suspense fallback={<Loader />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/jobs" element={<Jobs />} />
            <Route path="/jobs/map" element={<JobsMap />} />
            <Route path="/jobs/:id" element={<JobDetail />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/linkedin-callback" element={<LinkedInCallback />} />
            <Route path="/companies" element={<Companies />} />
            <Route path="/candidates/:slug" element={<CandidatePublic />} />
            <Route path="/pricing" element={<Pricing />} />

            {/* Rutas protegidas — candidato */}
            <Route path="/dashboard/candidate/*" element={
              <ProtectedRoute role="candidate"><CandidateDashboard /></ProtectedRoute>
            } />

            {/* Rutas protegidas — empresa */}
            <Route path="/dashboard/company/*" element={
              <ProtectedRoute role="company"><CompanyDashboard /></ProtectedRoute>
            } />
            <Route path="/dashboard/admin/*" element={
              <ProtectedRoute role="admin"><AdminDashboard /></ProtectedRoute>
            } />
            <Route path="/jobs/new" element={
              <ProtectedRoute role="company"><NewJob /></ProtectedRoute>
            } />
            <Route path="/jobs/:id/edit" element={
              <ProtectedRoute role="company"><NewJob edit /></ProtectedRoute>
            } />

            <Route path="*" element={<NotFound />} />
          </Routes>
        </React.Suspense>
      </main>
      <Footer />
    </>
  );
}

export default function App() {
  return (
    <HelmetProvider><AuthProvider><BrowserRouter basename={getCountryBase()}><AppLayout /></BrowserRouter></AuthProvider></HelmetProvider>
  );
}
